import React from 'react'
import styled from '@emotion/styled'
import PropTypes from 'prop-types'

import EmailIcon from '@mui/icons-material/Email'
import PhoneIcon from '@mui/icons-material/Phone'
import ContactSupportIcon from '@mui/icons-material/ContactSupport'

import BodyText, { BoldBodyText, LinkText } from '../styles/Text'
import { FlexColumn } from '../styles/Containers'

const SUPPORT_PORTAL_URL = 'https://vivacitadel.atlassian.net/servicedesk/customer/portal/1'

const Container = styled(FlexColumn)`
  gap: 10px;

  svg {
    width: 19px;
    height: 19px;
  }
`

const Item = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`

const SupportInfo = ({ text, email, phone, supportPortal = false }) => (
  <Container>
    <BoldBodyText>{text}</BoldBodyText>
    {supportPortal && (
      <Item>
        <ContactSupportIcon />
        <BodyText>
          <LinkText href={SUPPORT_PORTAL_URL} target="_blank" rel="noopener noreferrer">
            Support Portal
          </LinkText>
        </BodyText>
      </Item>
    )}
    <Item>
      <EmailIcon />
      <BodyText>
        <LinkText href={`mailto:${email}?subject=In App Support`} target="_blank" rel="noopener noreferrer">
          {email}
        </LinkText>
      </BodyText>
    </Item>
    {phone && (
      <Item>
        <PhoneIcon />
        <BodyText>{phone}</BodyText>
      </Item>
    )}
  </Container>
)

SupportInfo.propTypes = {
  text: PropTypes.string,
  email: PropTypes.string.isRequired,
  phone: PropTypes.string.isRequired,
  supportPortal: PropTypes.bool
}

export default SupportInfo
